export default __webpack_public_path__ + "static/logo-56a2cdba6e504684d1df25eb18f9aa76.svg";